module.exports = __webpack_public_path__ + "img/SubscriptionTypes.a26af9ba.svg";